import React, { useState, useEffect } from 'react';
import { Select } from 'antd';
import { useSelector } from 'react-redux';
import { addressesSelector, housesSelector } from '../../store/selectors';
import { setAddresses } from '../../store/actions';
import useRequestAddresses from '../../../../queries/useRequestAddresses';
import useFilterChange from '../../hooks/useFilterChange';
import { filterDelay } from '../../constants/common';

const SelectAddresses = ({ className }) => {
  const selectedHouses = useSelector(housesSelector);
  const selectedAddresses = useSelector(addressesSelector);

  const [value, setValue] = useState(selectedAddresses);

  const { data: addresses, isFetching: isAddressesFetching } =
    useRequestAddresses(selectedHouses[0], {
      staleTime: Infinity,
      enabled: Boolean(selectedHouses.length),
    });

  const change = useFilterChange({ action: setAddresses, delay: filterDelay });

  const handleChange = (values) => {
    setValue(values);
    change(values);
  };

  useEffect(() => {
    setValue(selectedAddresses);
  }, [selectedAddresses]);

  return (
    <Select
      onChange={handleChange}
      className={className}
      loading={isAddressesFetching}
      mode="multiple"
      defaultActiveFirstOption={false}
      allowClear
      placeholder="Кв/офис"
      value={addresses?.length ? value : []}
      optionFilterProp="searchtext"
    >
      {addresses?.map((address) => (
        <Select.Option
          key={address.id}
          value={address.id}
          searchtext={address.name}
        >
          {address.name}
        </Select.Option>
      ))}
    </Select>
  );
};

export default SelectAddresses;
